export default __webpack_public_path__ + "static/media/lion_New.f6941497.svg";